var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#491f69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 25.3333C22.4928 25.3333 25.3333 22.4928 25.3333 19V9.50001C25.3333 5.98976 22.507 3.13342 19.0332 3.13342C18.9218 3.13409 18.8108 3.14737 18.7023 3.17301C17.0766 3.25182 15.5434 3.95257 14.42 5.13025C13.2965 6.30792 12.6688 7.87241 12.6666 9.50001V19C12.6666 22.4928 15.5071 25.3333 19 25.3333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 31.5574V34.8333H20.5834V31.5574C26.8201 30.7737 31.6667 25.4489 31.6667 19H28.5C28.5 24.2393 24.2393 28.5 19 28.5C13.7608 28.5 9.50004 24.2393 9.50004 19H6.33337C6.33337 25.4473 11.18 30.7737 17.4167 31.5574Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.06cf2e22e46a35459ba5f009dde8f4ff.svg";
export { ForwardRef as ReactComponent };